/** Minutes since midnight of an 'HH:MM' clock. */
export function clockMinutes(clock: string): number {
  const [hours, minutes] = clock.split(':').map(Number);
  return (hours || 0) * 60 + (minutes || 0);
}

/** '09:00' reads as '9:00 AM'. */
export function formatClock(clock: string): string {
  const total = clockMinutes(clock);
  const hours = Math.floor(total / 60) % 24;
  const minutes = total % 60;
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  return (
    hour12 +
    ':' +
    String(minutes).padStart(2, '0') +
    (hours < 12 ? ' AM' : ' PM')
  );
}

/** Half-hour choices for a time picker. */
export function clockOptions(): string[] {
  const options: string[] = [];
  for (let minutes = 0; minutes < 24 * 60; minutes += 30) {
    options.push(
      String(Math.floor(minutes / 60)).padStart(2, '0') +
        ':' +
        String(minutes % 60).padStart(2, '0')
    );
  }
  return options;
}
